import createProps from '@kissui/helpers/src/props.helpers'
import { lazyLoad } from '@kissui/helpers/src/utils'
import createRefs from '@kissui/helpers/src/refs.helpers'
import { getCupSize } from '@kissui/helpers/src/cupsizes.helpers'

class CupSize extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.render()
        this.refs = createRefs(this)
        this.initLazyLoad()
    }

    initLazyLoad() {
        const { image } = this.props
        const path = '/shared_res/agility/next-components/assets/cup-size/'
        const { visual } = this.refs
        let src = ''

        if (image.custom !== '') {
            src = image.custom
        } else {
            src = path + image.predefined + '.png'
        }

        if (visual && image) {
            lazyLoad(visual, 'src', `${src}`, src)
        }
    }

    render() {
        const { label, a11y_label } = this.props

        this.innerHTML = `
            <img src='' data-ref="visual" aria-hidden='true' alt="" />
            <h3 class='t-sm-700' aria-description='${a11y_label}'>${label}</h3>
            ${this.renderVolume()}
        `
    }

    renderVolume() {
        const { volume } = this.props

        let volumeRender = ''

        if (volume.automatic || volume.automatic === 'true') {
            volumeRender = '(' + getCupSize(volume.size, volume.unit === 'oz') + ')'
        } else {
            volumeRender = volume.override
        }

        return `<p class='t-sm-400'>${volumeRender}</p>`
    }
}

customElements.get('nb-cup-size') || customElements.define('nb-cup-size', CupSize)
export default CupSize
